import styled from "styled-components";

export const ScrollableTableContainer = styled.div`
  max-height: 100%;
`;


export const StickyHeader = styled.thead`
  position: sticky;
  top: 57px;
  z-index: 10;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;


export const StyledTr = styled.tr`
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;
